import React from 'react'
import {Box, Tooltip} from '@mui/material'
import {ISegment} from '@containers/monitoringPlatform/passengerVerification/helpers/buildSegments'
import {formatRange} from '@containers/monitoringPlatform/passengerCharts/helpers/formatTime'
import SegmentMiniChart from '@containers/monitoringPlatform/passengerVerification/segments/SegmentMiniChart'
import sx from '@containers/monitoringPlatform/passengerVerification/segments/sx'

interface IProps {
	segments: ISegment[]
	activeKey: string | null
	onSelect: (segment: ISegment) => void
}

const SegmentsTable = ({segments, activeKey, onSelect}: IProps) => {
	return (
		<Box sx={sx.table}>
			<Box sx={{...sx.row, ...sx.head}}>
				<span>№</span>
				<span>Міжзупинковий перегін</span>
				<span>Час</span>
				<Box component="span" sx={{textAlign: 'right'}}>Пас.</Box>
			</Box>
			{segments.map((segment, index) => (
				<Tooltip
					key={segment.key}
					title={<SegmentMiniChart segment={segment}/>}
					placement="left"
					enterDelay={200}
				>
					<Box
						sx={sx.row}
						className={[segment.key === activeKey ? 'active' : '', segment.avg == null ? 'empty' : ''].join(' ')}
						onClick={() => onSelect(segment)}
					>
						<Box component="span" sx={sx.index}>{index + 1}</Box>
						<Box component="span" sx={sx.stops}>{segment.fromStop} → {segment.toStop}</Box>
						<Box component="span" sx={sx.time}>{formatRange(segment.from, segment.to)}</Box>
						<Box component="span" sx={sx.count}>
							{segment.avg == null ? '—' : `${segment.estimated ? '≈' : '~'}${segment.avg}`}
						</Box>
					</Box>
				</Tooltip>
			))}
		</Box>
	)
}

export default SegmentsTable
